import AutoButtonsField from "./AutoButtonsField.mjs";
import RadioOnIcon from "../../media/images/RadioOnIcon.mjs";
import RadioOffIcon from "../../media/images/RadioOffIcon.mjs";

export default class AutoRadioFields extends AutoButtonsField {
	componentDidMount() {
		super.componentDidMount();
		const opts = this.state.options;
		opts.forEach( o => {
			o.iconActive = <RadioOnIcon />;
			o.iconInactive = <RadioOffIcon/>;
		});
		this.setState({options: opts});
	}
}
